import React from 'react';
import { NiceFormGroup } from './Components.styles';
import { Tooltip } from 'react-tippy';
import { TooltipContent } from 'Waves/Waves.styles';
import { ApIcon, colors } from '@alixpartners/ui-components';
import TextInput from './TextInput';

function DropdownInput({
	label,
	handleChange,
	options,
	selectedValue,
	name,
	instructions,
}) {
	return (
		<>
			<NiceFormGroup>
				<div style={{ display: 'flex', alignItems: 'center' }}>
					<label>{label}</label>
					{instructions && (
						<Tooltip
							position="bottom"
							animation="fade"
							arrow
							html={<TooltipContent>{instructions}</TooltipContent>}
							trigger="mouseenter"
							style={{ marginBottom: '4px', marginLeft: '5px' }}
						>
							<ApIcon
								iconName="info"
								iconSize="22px"
								outlined={true}
								iconColor={colors.green300}
							/>
						</Tooltip>
					)}
				</div>
				<select
					name={name}
					id={name}
					value={selectedValue?.[0]}
					onChange={handleChange}
					required
				>
					<option hidden> -- select an option -- </option>

					{options.map(({ id, label }) => {
						let uniqueId = name + id;

						return (
							<option key={uniqueId} value={label}>
								{label}
							</option>
						);
					})}
				</select>
				{selectedValue?.[0] === 'Other' && (
					<TextInput
						label="Other"
						placeholder="Type here"
						onChange={handleChange}
						name={name}
						value={selectedValue[1]}
						required
					/>
				)}
			</NiceFormGroup>
		</>
	);
}

export default DropdownInput;
